import { useAuth0 } from "@auth0/auth0-react";
import router from "next/router";
import { useEffect, useState } from "react";
import { LoadingPage } from "../src/components/LoadingPage";
import { AUTH0_SCOPE } from "../src/constants/env";

const LoginPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted) return;

    if (!isAuthenticated && !isLoading) {
      loginWithRedirect({
        scope: AUTH0_SCOPE,
        redirectUri: window.location.origin + "/redirect?authType=auth0"
      });
    }
    if (isAuthenticated && !isLoading) {
      router.push({
        pathname: "/redirect"
      });
    }
  }, [isMounted, isAuthenticated, isLoading, loginWithRedirect]);

  return <LoadingPage />;
};

export default LoginPage;
